import CalculatorsForm       from "./components/optimizations/CalculatorsForm";
import CantProduction       from "./components/optimizations/CantProduction";
import CompaniesManagement  from "./components/admin/CompaniesManagement";
import ContactsInfo         from "./components/ContactsInfo";
import ContractsForm        from "./components/catalogs/ContractsManagement.vue";
import DiamOptimization     from "./components/optimizations/DiamOptimization";
import EditAccount          from "./components/account/EditAccount";
import EditACL              from "./components/admin/EditACL";
import EquipmentProfiles    from "./components/catalogs/EquipmentProfiles";
import HomePage             from "./components/HomePage";
import LengthsManagement    from "./components/catalogs/LengthsManagement";
import LimitsManagement     from "./components/admin/LimitsManagement";
import LoadTesting          from "./components/admin/LoadTesting";
import LumberManagement     from "./components/catalogs/LumberManagement";
import OptimizationForm     from "./components/optimizations/OptimizationForm";
import PasswordResetDialog  from "./components/dialogs/PasswordResetDialog";
import PatternsManagement   from "./components/patterns/PatternsManagement";
import PricesManagement     from "./components/catalogs/PricesManagement";
import RegistrationDialog   from "./components/dialogs/RegistrationDialog";
import SettingsForm         from "./components/catalogs/SettingsForm";
import SpeciesManagement    from "./components/catalogs/SpeciesManagement";
import SubscriptionForm     from "./components/account/SubscriptionForm";
import SupportForm          from "./components/help/SupportForm";
import SysLog               from "./components/admin/SysLog";
import TariffsInfo          from "./components/account/TariffsInfo";
import ThreeDManagement     from "./components/patterns/ThreeDManagement";
import TutorialsVue         from "./components/help/TutorialsVue";
import UsersManagement      from "./components/admin/UsersManagement";

const routes = [
    { path: "/account",      component: EditAccount },
    { path: "/acl",          component: EditACL },
    { path: "/calculators",  component: CalculatorsForm },
    { path: "/cant_opt",     component: CantProduction },
    { path: "/companies",    component: CompaniesManagement },
    { path: "/contacts",     component: ContactsInfo },
    { path: "/contracts",    component: ContractsForm },
    { path: "/diam_opt",     component: DiamOptimization },
    { path: "/equipment",    component: EquipmentProfiles },
    { path: "/home",         component: HomePage },
    { path: "/lengths",      component: LengthsManagement },
    { path: "/limits",       component: LimitsManagement },
    { path: "/load_test",    component: LoadTesting },
    { path: "/lumber",       component: LumberManagement },
    { path: "/optimization", component: OptimizationForm },
    { path: "/patterns",     component: PatternsManagement },
    { path: "/prices",       component: PricesManagement },
    { path: "/register",     component: RegistrationDialog },
    { path: "/reset_pwd",    component: PasswordResetDialog },
    { path: "/settings",     component: SettingsForm },
    { path: "/species",      component: SpeciesManagement },
    { path: "/subscription", component: SubscriptionForm },
    { path: "/support",      component: SupportForm },
    { path: "/syslog",       component: SysLog },
    { path: "/three_d",      component: ThreeDManagement },
    { path: "/tariffs",      component: TariffsInfo },
    { path: "/tutorials",    component: TutorialsVue },
    { path: "/users",        component: UsersManagement },
];

export default routes;
